<template>
    <div v-cloak v-if="auth">
        <div class="row mb-3">
            <div class="col-12">
                <div class="row form-group">
                    <div class="col-12"><label for="person-search">{{ $lang('Imię i nazwisko:') }}</label></div>
                    <div class="col-8 col-md-10">
                        <input
                            class="form-control d-inline-block w-100 w-md-auto mr-3"
                            id="person-search"
                            type="text"
                            v-model="search"
                            @keydown="searchInputKeyDown"
                            :placeholder="$lang('Wyszukaj osobę') + '...'"
                        >
                    </div>
                    <div class="col-4 col-md-2 form-group">
                        <button class="btn btn-primary btn-block text-nowrap" @click.prevent="searchButtonClick">
                            <span>{{ $lang('Szukaj') }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <pagination-component
            :pagination="pagination"
            :key="'pagination-1-'+ (pagination.current_page ? pagination.current_page : 1)"
        ></pagination-component>
        <div class="simple-table structure-table" v-if="logsList.length">
            <table class="table table-striped table-sm table-hover mb-0">
                <table-headers :headers="tableHeaders"></table-headers>
                <tbody>
                <tr v-for="(log, index) in logsList">
                    <td :data-title="$lang('Lp.')">
                        {{ pagination.from + index }}
                    </td>
                    <td :data-title="$lang('Imię i nazwisko')">
                        <span href="">{{ log.person.name + " " + log.person.surname }}</span>
                    </td>
                    <td :data-title="$lang('Adres IP')">
                        <span href="">{{ log.ip }}</span>
                    </td>
                    <td :data-title="$lang('Data rezygnacji')">
                        <span href="">{{ log.date }}</span>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-else>
            {{ $lang('Brak wyników') }}
        </div>
        <pagination-component
            :pagination="pagination"
            :key="'pagination-2-'+ (pagination.current_page ? pagination.current_page : 1)"
        ></pagination-component>
    </div>
</template>
<script>

import axios from 'axios';
import Notification from '../../mixins/show-notification';
import {EventBus} from "../../mixins/event-bus";
import TableHeaders from '../table/table-headers';
import PaginationComponent from '../pagination-component';

export default {

    name: 'unsubscribe-logs-table',

    components: {
        TableHeaders,
        PaginationComponent,
    },

    mixins: [Notification],

    props: {
        auth: {
            type: Boolean,
            required: true
        },
        list_route: {
            type: String,
        },
    },

    data() {
        return {
            logsList: [],
            pagination: [],
            perPage: 20,
            search: "",
            sortColumn: 'name',
            sortOrder: 'asc',
            tableHeaders: [
                {title: this.$lang('Lp.')},
                {title: this.$lang('Imię i nazwisko'), column: 'name', sort: 'alpha'},
                {title: this.$lang('Adres IP'), column: 'ip', sort: 'numeric'},
                {title: this.$lang('Data rezygnacji'), column: 'date', sort: 'numeric'},
            ],
        };
    },
    created() {
        this.setEventBusListeners();
        this.requestLogs();
    },

    watch: {
        libraryID() {
            this.requestLogs();
        },
        sortColumn() {
            this.requestLogs();
        }
    },

    methods: {
        confirm(filename) {
            this.deleteImage(filename);
        },

        requestLogs(filters) {
            const params = {
                ...filters,
                perPage: this.perPage,
                sortColumn: this.sortColumn,
                sortOrder: this.sortOrder,
                search: this.search
            };
            return axios.get(this.list_route, {params}).then((response) => {
                this.logsList = response.data.logs.data;
                this.pagination = response.data.logs;
            }).catch((error) => {
                const message = (error.response.data ? error.response.data : error.response.statusText);
                this.showNotification('error', message);
            });
        },

        searchInputKeyDown(event) {
            if (event.keyCode === 13) {
                this.requestLogs();
            }
        },

        searchButtonClick() {
            this.requestLogs();
        },

        onChangePage({ value }) {
            this.requestLogs({ page: value });
        },

        onSortByColumn({ column, order }) {
            this.sortColumn = column;
            this.sortOrder = order;

            this.requestLogs({ page: this.pagination.current_page });
        },

        setEventBusListeners() {
            EventBus.$on('changePage', this.onChangePage)
                .$on('sortByColumn', this.onSortByColumn);
        },
    }

}

</script>
